"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.696 2.078a3.174 3.174 0 0 0-3.874 3.096v.292a2.65 2.65 0 0 0-1.87 2.533v3.35a2.65 2.65 0 0 0 2.65 2.65h4.795a2.65 2.65 0 0 0 2.65-2.65v-3.35q0-.31-.068-.6a4.4 4.4 0 0 1-1.573-.297c.212.239.341.553.341.897v3.35a1.35 1.35 0 0 1-1.35 1.35H5.602a1.35 1.35 0 0 1-1.35-1.35v-3.35c0-.745.605-1.35 1.35-1.35h4.795q.08 0 .158.01a4.4 4.4 0 0 1-1.276-1.31H6.222v-.175A1.774 1.774 0 0 1 8.63 3.517a4.5 4.5 0 0 1 .066-1.439"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.01 9.114c0 .313-.143.593-.365.779v.954a.65.65 0 1 1-1.3 0v-.955a1.014 1.014 0 1 1 1.664-.778"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13 .299a.7.7 0 0 1 .7.7v1.3H15a.7.7 0 1 1 0 1.4h-1.3v1.3a.7.7 0 1 1-1.4 0v-1.3H11a.7.7 0 1 1 0-1.4h1.3v-1.3a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=LockAddIcon16.js.map